<template>
    <div class="about">
      
      <div class="txt">
        <a href="https://www.miit.gov.cn/" target="blank" >友情链接 &nbsp; &nbsp;国家工信部</a><span>·</span>宁波经信委
        <span>·</span> <a href="http://www.cmca-view.com/" target="blank" >中国机械通用零部件工业协会</a>
   
      <span>·</span><a href="http://www.tengzhicn.com/reception/index.html" target="blank" > 腾智软件</a>
        <span>·</span><a href="http://www.tenglonggroup.com/" target="blank" >腾龙精线</a>
    
      </div>
    </div>
   <div class="footer">
      <div class="center">
        <div class="left"></div>
        <div class="copy">
         <span @click="go('/association/general')">关于协会</span>  &nbsp;&nbsp;|
          &nbsp;&nbsp;<span  @click="go('/privacy')">隐私声明</span> &nbsp;&nbsp;| &nbsp;&nbsp; <span @click="go('/about/contactInfo')">联系我们</span>
        </div>
        <div class="put" @click="to">
            宁波紧固件工业协会版权所有&nbsp;&nbsp;| &nbsp;&nbsp; <a >浙ICP备2025190193号</a>
        </div>
        <div class="phone">服务电话： {{phone}} <span><a href="http://www.fastener-cn.net/login.html" target="blank" style="color:#1890FF;">后台管理</a></span></div>
      </div>
    </div>
</template>

<script>
import { useRouter } from "vue-router";
import {onMounted,toRefs,reactive} from 'vue'
import {getPhone} from '@/api/index.js'
export default {

      setup(){
         const data=reactive({
          phone:''
         })

         const to = () =>{
        window.open('https://beian.miit.gov.cn/#/Integrated/index')
      }
        const router=useRouter()
        function go(item){
          console.log('关于协会')
          router.push({
            path:item
          })
        }
        onMounted(()=>{
          getPhone({}).then(res =>{
        console.log(res,'手机号码')
        data.phone=res.dataList.corp_tel
      })

    

    
        })
        return {
          ...toRefs(data),router,go,to
        }
      }
}
</script>

<style lang="scss" scope>
  .footer {
    height: 21.8rem;
    background: #ffffff;
    width: 100%;
    margin-bottom: 3rem;

    .center {
      width: 60rem;
      height: 21.8rem;
      font-size: 1.8rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 3.2rem;
      margin: 0 auto;

      overflow: hidden;
      a {
        color: #999999;
      }

      .left {
        height: 5.2rem;
        width: 30rem;
        background-image: url(../assets/logo.png);
        background-size: 94%, 100%;
        background-repeat: no-repeat;

        margin: 0 auto;
        margin-top: 3.3rem;
        margin-bottom: 1rem;
      }

      .phone {
        span {
          color: #5690c3;
          margin-left: 0.6rem;
        }
      }

      .copy {
        width: 60rem;

        font-size: 1.8rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 3.2rem;
        margin: 0 auto;
      }

      .put {
        margin: 1rem 0;
      }
    }
  }
  
  .about {
    display: flex;
    margin-top: 5rem;
    align-items: center;
    height: 8.2rem;
    padding-left:54.4rem;
    background: #4a506b;
    font-size: 2rem;
    height: 8.2rem;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #ffffff;

    span {
      font-size: 1rem;
      margin-left: 1rem;
    }

    .txt {
      margin-left: 50px;
      font-size: 2rem;
      height: 8.2rem;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #ffffff;
      text-align: left;
      display: flex;
      opacity: 0.8;

      span {
        font-size: 1rem;
        margin-left: 1rem;
        margin-right: 1rem;
      }

      align-items: center;
    }
  }
</style>